module.exports = __webpack_public_path__ + "static/img/vipVisit.f718b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vipVisit.png
// module id = R587
// module chunks = 1